export class ValidationExpressions {
  public static guestName: string = '^[a-zA-Z ]*$';
  public static ticketNumber: string = '^[0-9]{13}$';
  public static wviBookingId: string = '^[0-9]{7}$';
}



// WEBPACK FOOTER //
// ./src/app/shared/validation/validation.expressions.ts